import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { InvestmentQuoteResponse, fetchInvestmentQuote } from "@features/investments/api";
import { INVESTMENTS_QUOTE_POLL_MS } from "@features/investments/state/constants";

export const investmentQuoteQueryKey = (ticker: string) => ["investments", "quote", ticker] as const;

export function useInvestmentQuoteQuery(ticker: string, enabled = true): UseQueryResult<InvestmentQuoteResponse, Error> {
  return useQuery({
    queryKey: investmentQuoteQueryKey(ticker),
    queryFn: () => fetchInvestmentQuote(ticker),
    enabled: enabled && ticker.trim() !== "",
    retry: false,
    refetchInterval: enabled ? INVESTMENTS_QUOTE_POLL_MS : false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
}
